__turbopack_context__.v({
  "media": "Topic-module-scss-module__wjDoXq__media",
});
